import {
    Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, FormFeedback
} from 'reactstrap';

const OrganizationForm = ({
    modal,
    setModal,
    isModifying,
    orgValidation
}) => {

    const toggle = () => setModal(!modal)

    return (
        <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader toggle={toggle}>Enter the organization details</ModalHeader>
            <Form onSubmit={(e) => {
                e.preventDefault()
                orgValidation.handleSubmit()
            }}
            >
                <ModalBody>
                    <FormGroup>
                        <Label for="username">Branch Name</Label>
                        <Input
                            type="text"
                            name="branch"
                            id="branch"
                            placeholder="Enter branch name"
                            onChange={orgValidation.handleChange}
                            onBlur={orgValidation.handleBlur}
                            value={orgValidation.values.branch || ""}
                            invalid={
                                orgValidation.touched.branch && orgValidation.errors.branch
                                    ? true
                                    : false
                            }
                        />
                        {orgValidation.touched.branch && orgValidation.errors.branch ? (
                            <FormFeedback type="invalid">
                                {orgValidation.errors.branch}
                            </FormFeedback>
                        ) : null}
                    </FormGroup>
                    <FormGroup>
                        <Label for="agency">Agency</Label>
                        <Input
                            type="text"
                            name="agency"
                            id="agency"
                            placeholder="Enter agency"
                            onChange={orgValidation.handleChange}
                            onBlur={orgValidation.handleBlur}
                            value={orgValidation.values.agency || ""}
                            invalid={
                                orgValidation.touched.agency && orgValidation.errors.agency
                                    ? true
                                    : false
                            }
                        />
                        {orgValidation.touched.agency && orgValidation.errors.agency ? (
                            <FormFeedback type="invalid">
                                {orgValidation.errors.agency}
                            </FormFeedback>
                        ) : null}
                    </FormGroup>
                    <FormGroup>
                        <Label for="office">Office</Label>
                        <Input
                            type="text"
                            name="office"
                            id="office"
                            placeholder="Enter office name"
                            onChange={orgValidation.handleChange}
                            onBlur={orgValidation.handleBlur}
                            value={orgValidation.values.office || ""}
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label for="city">City</Label>
                        <Input
                            type="text"
                            name="city"
                            id="city"
                            placeholder="Enter city name"
                            onChange={orgValidation.handleChange}
                            onBlur={orgValidation.handleBlur}
                            value={orgValidation.values.city || ""}
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label for="state">State</Label>
                        <Input
                            type="text"
                            name="state"
                            id="state"
                            placeholder="Enter state name"
                            onChange={orgValidation.handleChange}
                            onBlur={orgValidation.handleBlur}
                            value={orgValidation.values.state || ""}
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label for="city">Security Contact</Label>
                        <Input
                            type="number"
                            name="securityContact"
                            id="securityContact"
                            placeholder="Enter security contact"
                            onChange={orgValidation.handleChange}
                            onBlur={orgValidation.handleBlur}
                            value={orgValidation.values.securityContact || ""}
                        />
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <Button disabled={isModifying} color="primary" type="submit">Submit</Button>{' '}
                    <Button disabled={isModifying} color="secondary" onClick={toggle}>Cancel</Button>
                </ModalFooter>
            </Form>
        </Modal>
    )
}

export default OrganizationForm